module.exports = __webpack_public_path__ + "static/media/facebook.012e983c.svg";